import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { PropertyUpdateSynchronisationInfo } from '../../../../shared/models/entity-property-info/property-update-synchronisation-info';
import { NgClass } from '@angular/common';
import { DiffFieldViewer } from '../../common/diff/diff-field-viewer/diff-field-viewer';

@Component({
  selector: 'app-changes-in-other-versions-table',
  imports: [NgClass, DiffFieldViewer],
  templateUrl: './changes-in-other-versions-table.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './changes-in-other-versions-table.scss',
})
export class ChangesInOtherVersionsTable {
  @Input() public propertyUpdateInfo?: PropertyUpdateSynchronisationInfo;
  @Output() public propertyInfosUpdated = new EventEmitter<PropertyUpdateSynchronisationInfo>();

  public currentStep = 1;

  private checkedColumns: Record<string, boolean> = {};

  protected get currentStepFields(): string[] {
    return this.propertyUpdateInfo?.getFieldsByStep(this.currentStep) ?? [];
  }

  protected isColumnChecked(propertyName: string): boolean {
    return this.checkedColumns[propertyName] ?? false;
  }

  protected onCheckboxChange($event: Event, entityId: string, propertyName?: string): void {
    const isChecked = ($event.target as HTMLInputElement).checked;
    if (this.propertyUpdateInfo) {
      this.propertyUpdateInfo.confirmUpdatedValueToggle(entityId, propertyName ?? '', isChecked);
      this.propertyInfosUpdated.emit(this.propertyUpdateInfo);
    }
    // TODO: Maybe we should consider to extend the logic of the checked columns to also consider the state of the individual checkboxes.
  }

  protected onCheckboxChangeForColumn($event: Event, propertyName: string): void {
    const isChecked = ($event.target as HTMLInputElement).checked;
    if (this.propertyUpdateInfo) {
      this.propertyUpdateInfo.confirmAllUpdatedValuesForPropertyNameToggle(propertyName, isChecked);
      this.propertyInfosUpdated.emit(this.propertyUpdateInfo);
    }
    this.updateCheckedColumns(propertyName, isChecked);
  }

  private updateCheckedColumns(propertyName: string, isChecked: boolean): void {
    this.checkedColumns[propertyName] = isChecked;
  }
}
